import React, { useEffect, useState, useRef } from "react";
import { object, func, string, array } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import TopArrowContainer from "../../atoms/TopArrowContainer";
import ContributorImage from "../../atoms/ContributorImage";
import Button from "../../atoms/Button";
import EditIcon from "../../atoms/icons/edit";
import CommentIcon from "../../atoms/icons/comment";
import SaveIcon from "../../atoms/icons/save";
import HomeComments from "../../molecules/HomeComments";
import BookmarksPopup from "../../molecules/BookmarksPopup";
import LoadingIconComponent from "../../atoms/LoadingIconComponent";

import { useOuterClickNotifier, processComments } from "../../utils/utils";
import { getUserComments, getBookmarkStories } from "../../helper/api";
import { setHomeComments } from "../../helper/actions";
import { staticTexts } from "../../utils/Translate";

import "./loginFirstLook.m.css";

const LoginFirstLook = ({
  member,
  pageType,
  logout,
  navigateToPage,
  closeView,
  setHomeComments,
  commentList,
  jwtToken,
  metypeConfig,
  publisherAttributes
}) => {
  const viewRef = useRef(null);
  const [commentLoading, setCommentLoading] = useState(false);
  const [savedStoriesLoading, setSavedStoriesLoading] = useState(false);
  const [savedStoriesList, SetSavedStoriesList] = useState([]);

  useEffect(() => {
    // Load the comments only if comment list is empty
    if (!(commentList && commentList.length)) {
      getComments();
    }

    getSavedStories();
  }, []);

  useOuterClickNotifier(closeView, viewRef);

  const editProfileClick = () => navigateToPage(`/profile`);

  const getComments = () => {
    setCommentLoading(true);

    // Pull 4 records to check if there are more records. Ideally only 3 will be displayed
    getUserComments(metypeConfig, jwtToken, 1, 4)
      .then(data => setHomeComments(processComments(data)))
      .finally(() => setCommentLoading(false));
  };

  const getSavedStories = () => {
    setSavedStoriesLoading(true);

    getBookmarkStories(metypeConfig, jwtToken)
      .then(data => SetSavedStoriesList(data))
      .finally(() => setSavedStoriesLoading(false));
  };

  const noCommentsView = () => (
    <div styleName="no-comments-wrapper">
      <div styleName="no-comments-saved">
        <CommentIcon />
        <span styleName="title1">{staticTexts(publisherAttributes.lang).newsYouCommented}</span>
        <span styleName="title2">{staticTexts(publisherAttributes.lang).youDidntSaveComment}</span>
      </div>
    </div>
  );

  const noSavedStoriesView = () => (
    <div styleName="no-comments-saved">
      <SaveIcon />
      <span styleName="title1">{staticTexts(publisherAttributes.lang).newsYouSaved}</span>
      <span styleName="title2">{staticTexts(publisherAttributes.lang).youDidntSaveNews}</span>
    </div>
  );

  const processCommentsView = () => {
    // If comments are loading show the indicator within the popup
    if (commentLoading) {
      return (
        <div styleName="no-comments-wrapper">
          <LoadingIconComponent />
        </div>
      );
    }

    // If comments are there then load the comments
    if (commentList.length) {
      return (
        <div styleName="comments-wrapper">
          <HomeComments list={commentList} />
        </div>
      );
    }

    // No Comments View
    return noCommentsView();
  };

  const processSavedStories = () => {
    // If saved stories are loading show the indicator within the popup
    if (savedStoriesLoading) {
      return (
        <div styleName="no-comments-saved">
          <LoadingIconComponent />
        </div>
      );
    }

    if (savedStoriesList.length) {
      return (
        <div styleName="news-wrapper">
          <BookmarksPopup stories={savedStoriesList} navigateToPage={navigateToPage} />
        </div>
      );
    }

    // No Saved Stories View
    return noSavedStoriesView();
  };

  return (
    <div styleName="top-arrow-container-wrapper" ref={viewRef}>
      <TopArrowContainer closeView={closeView}>
        <div styleName="wrapper">
          <div styleName="profile">
            <div styleName="image-name-wrapper">
              <ContributorImage authorObj={member} />
              <span styleName="name">{member.name}</span>
            </div>
            {pageType !== "profile-page" ? (
              <div styleName="edit-profile-wrapper" onClick={editProfileClick}>
                <EditIcon />
                <span styleName="edit-profile">{staticTexts(publisherAttributes.lang).editProfile}</span>
              </div>
            ) : null}
          </div>

          <div styleName="comment-saved-news">
            <div styleName="comments-wrapper-border">{processCommentsView()}</div>
            <div styleName="news-wrapper">{processSavedStories()}</div>
          </div>

          <Button content={staticTexts(publisherAttributes.lang).logOut} buttonType="type4" onClick={logout} />
        </div>
      </TopArrowContainer>
    </div>
  );
};

LoginFirstLook.propTypes = {
  member: object.isRequired,
  pageType: string,
  navigateToPage: func,
  closeView: func,
  logout: func,
  setHomeComments: func,
  commentList: array,
  jwtToken: string,
  metypeConfig: object,
  publisherAttributes: object
};

const mapStateToProps = state => ({
  pageType: get(state, ["qt", "pageType"], ""),
  member: state.member || null,
  commentList: state.commentsReducer || [],
  jwtToken: get(state, ["userReducer", "jwt_token"], null),
  metypeConfig: get(state, ["qt", "config", "publisher-attributes", "metypeConfig"], {}),
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {})
});

const mapDispatchToProps = dispatch => ({
  setHomeComments: list => dispatch(setHomeComments(list)),
  navigateToPage: url => global.app.navigateToPage(dispatch, url)
});

export default connect(mapStateToProps, mapDispatchToProps)(LoginFirstLook);
